export const FETCHING_PARTS_LOCATION_DASHBOARD = '@@toyota/FETCHING_PARTS_LOCATION_DASHBOARD';
export const FETCHED_PARTS_LOCATION_DASHBOARD = '@@toyota/FETCHED_PARTS_LOCATION_DASHBOARD';
export const FETCHED_PARTS_LOCATION_DASHBOARD_FAILED = '@@toyota/FETCHED_PARTS_LOCATION_DASHBOARD_FAILED';
